import { Component, OnInit, Inject, ViewChild  } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { NgForm } from '@angular/forms';
import { AppUtilService } from '../../../core/utils/app-util.service';
import { OktaAuthService } from '../../../core/services/okta-auth.service';

import { OverlayContainer } from 'ngx-toastr';
import {
  CacheConstant,
  OktaErrorCodes,
  OktaOperationSource,
  OktaOperationType,
  CacheDuration,
  UserDeviceConstant
} from '../../../core/constants/app.constant';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { OktaConstant } from '../../../modules/okta/okta.constant';
import { AuthService } from '../../../core/services/auth.service';
import { OktaService } from '../okta.service';
import { OktaRoutes } from '../../../core/constants/routes.constant';
import { OktaOperation } from '../okta-operation';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { BaseComponent } from '../../../app.base.component';
import { AppConfigService } from '../../../../app/core/services/init/app-config.service';
import { DeviceDetectorService } from 'ngx-device-detector';


@Component({
  selector: 'par-login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.scss']
})
export class LoginDialogComponent extends  BaseComponent implements OnInit {
  /***************Properties***************/
  @ViewChild('loginForm', { static: false }) loginForm: NgForm;
  login = {
    username: '',
    password: '',
    errorMessage: '',
    isSessionTimeOut: false
  };
  /***************Properties***************/
  websiteName: string = this.cache.get(CacheConstant.Env_Properties).theme;
  /***************Constructor***************/
  constructor(
    private cache: AppCacheService,
    public dialogRef: MatDialogRef<LoginDialogComponent>,
    private oktaAuthService: OktaAuthService,
    private oktaService: OktaService,
    private authService: AuthService,
    private loader: LoadingBarService,
    private overlayContainer: OverlayContainer,
    @Inject(MAT_DIALOG_DATA) public data: any,
    
  deviceDetectorService: DeviceDetectorService,
     private appConfig: AppConfigService,
 
   ) {
     super(deviceDetectorService, cache, appConfig);
   }

  ngOnInit() {
    this.login.isSessionTimeOut = this.data && this.data.isSessionTimeout;
  }
  /***************Constructor***************/

  /***************Component Methods***************/

  onForgotPasswordClick(){
    AppUtilService.router.navigate(['/forgot-password']);
    this.dialogRef.close();
  }
  onSignInSubmit() {
    AppUtilService.cache.remove(CacheConstant.Okta_Session_Id);
    AppUtilService.cache.remove(CacheConstant.User_Id);
    this.login.errorMessage = null;

    if (!this.login.username || !this.login.password) {
      return;
    }

    this.loader.start();

    this.oktaService
      .isMigrated(this.login.username)
      .subscribe((migrateResponse: any) => {
        if (
          migrateResponse &&
          !migrateResponse.hasError &&
          migrateResponse.userId &&
          migrateResponse.migratedUser
        ) {
          this.authenticateIdm();
        } else {
          this.authenticateOkta();
        }
      });
  }

  /***************Component Methods***************/

  /***************Private Methods***************/

  private authenticateOkta() {
    this.oktaAuthService
      .signIn(this.login.username, this.login.password)
      .then(response => {
        if (!response.errorCode) {
          if(response.user!=null) {
            AppUtilService.cache.set(
              CacheConstant.Okta_User_Id,
              response.user.id);
          } 
          if (response.status === 'PASSWORD_EXPIRED') {
            this.onOktaAuthSuccess(response);
            AppUtilService.cache.set(
              CacheConstant.Okta_User_Id,
              response.user.id
            );
            return;
          }

          if (response === 'USER_LOCKED') {
            this.onAuthError('USER_LOCKED');
            return;
          }

          if (!AppUtilService.isApple()) {
            this.oktaAuthService
              .authorize(response)
              .then(tokens => {
                this.onOktaAuthSuccess(response);
              })
              .catch(error => {
                this.onAuthError(error);
              });
          } else {
            this.oktaAuthService
              .createOktaSession(response.sessionToken)
              .subscribe((sessionResponse: any) => {
                if (sessionResponse && !sessionResponse.hasError) {
                  AppUtilService.cache.set(
                    CacheConstant.Okta_Session_Id,
                    sessionResponse.id
                  );
                  this.onOktaAuthSuccess(response);
                } else {
                  this.onAuthError('error creating session');
                }
              });
          }
        } else {
          this.onAuthError(response);
        }
      });
  }

  private onOktaAuthSuccess(response) {
    AppUtilService.cache.set(CacheConstant.User_Id, this.login.username);
    AppUtilService.cache.set(CacheConstant.Okta_Authenticated, true);
    //To show login popup after session expired
    AppUtilService.cache.set(CacheConstant.Show_Login_Popup, true);
    this.dialogRef.close(response);
  }

  private onAuthError(response) {
    if (response === 'USER_LOCKED') {
      this.login.errorMessage = OktaConstant.Messages.UserLockedMessage;
    } else {
      this.login.errorMessage =
        this.oktaAuthService.getErrorMessageByCode(response.errorCode) ||
        response.message;
    }
    this.login.password = '';
    AppUtilService.cache.set(CacheConstant.Okta_Authenticated, false);
    this.loader.complete();
  }

  private authenticateIdm() {
    this.authService
      .authenticateIdm(this.login.username, this.login.password)
      .subscribe((authResponse: any) => {
        if (
          authResponse &&
          !authResponse.hasError &&
          authResponse.recoveryToken &&
          authResponse.oktaId
        ) {
          this.verifyToken(authResponse.recoveryToken);
        } else {
          this.onAuthError({ errorCode: OktaErrorCodes.Auth_Failed });
        }
      });
  }

  private verifyToken(recoveryToken) {
    this.oktaService
      .verifyToken(recoveryToken)
      .subscribe((tokenResponse: any) => {
        if (!tokenResponse.hasError) {
          tokenResponse.verified = true;

          const operation: OktaOperation = {
            data: tokenResponse,
            source: OktaOperationSource.ActivateNonMigrateUser,
            type: OktaOperationType.ActivateNonMigrateUser
          };
          operation.data.token = recoveryToken;

          AppUtilService.cache.set(
            CacheConstant.Okta_Operation,
            operation,
            CacheDuration.OneMinute
          );

          this.dialogRef.close(null);
          this.loader.complete();
          AppUtilService.router.navigate([OktaRoutes.ActivateUser]);
        } else {
          this.onAuthError({ errorCode: OktaErrorCodes.Auth_Failed });
        }
      });
  }

  /***************Private Methods***************/
}
